// コンテンツをランダムに返す
export const selectByRandom = (array, selectNum) => {
  let newArray = []
  let copiedArray = []
  Object.assign(copiedArray, array)

  while (newArray.length < selectNum && copiedArray.length > 0) {
    const rand = Math.floor(Math.random() * copiedArray.length)
    newArray.push(copiedArray[rand])
    copiedArray.splice(rand, 1)
  }

  return newArray
}
  
  